import ModalVideo from 'modal-video'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

new ModalVideo('.js-modal-video')

const observer = new MutationObserver(function (mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      if (
        mutation.addedNodes.length > 0 &&
        mutation.addedNodes[0].classList &&
        mutation.addedNodes[0].classList.contains('modal-video')
      ) {
        disableBodyScroll(mutation.addedNodes[0])
      }
      if (
        mutation.removedNodes.length > 0 &&
        mutation.removedNodes[0].classList &&
        mutation.removedNodes[0].classList.contains('modal-video')
      ) {
        enableBodyScroll(mutation.removedNodes[0])
      }
    }
  }
})
observer.observe(document.body, {
  childList: true
})
